import { useSEO, faqSchema } from "../lib/seo";
import { Reveal } from "../components/Reveal";
import { CTASection, FAQ } from "../components/Sections";
import { getService } from "../data/services";

export default function ServicePage({ slug }) {
  const s = getService(slug);
  useSEO({
    title: s.metaTitle,
    description: s.metaDescription,
    path: `/${s.slug}`,
    image: s.image,
    jsonLd: faqSchema(s.faqs),
  });

  return (
    <div data-testid={`service-page-${s.key}`}>
      <section className="relative overflow-hidden">
        <div className="mx-auto max-w-7xl px-6 pb-12 pt-36 md:px-12 md:pt-44">
          <Reveal>
            <p className="overline">{s.overline}</p>
            <h1 className="mt-5 max-w-4xl font-serif text-4xl font-light leading-[1.08] tracking-tight text-ink md:text-6xl">
              {s.h1}
            </h1>
            <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-soft">{s.intro}</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 md:px-12">
        <Reveal>
          <div className="overflow-hidden rounded-[2rem]">
            <img src={s.image} alt={s.imageAlt || `Psicóloga sanitaria en Málaga · ${s.name}`} loading="lazy" className="h-[38vh] w-full object-cover md:h-[52vh]" />
          </div>
        </Reveal>
      </section>

      <section className="mx-auto max-w-3xl px-6 py-20 md:py-28">
        <Reveal>
          <article className="prose-therapy" dangerouslySetInnerHTML={{ __html: s.content }} data-testid={`service-content-${s.key}`} />
        </Reveal>

        <Reveal>
          <h2 className="mb-8 font-serif text-3xl font-light text-ink md:text-4xl">Preguntas frecuentes</h2>
          <FAQ faqs={s.faqs} testId={`service-faq-${s.key}`} />
        </Reveal>
      </section>

      <CTASection title={s.ctaTitle} text={s.ctaText} testId={`service-cta-bottom-${s.key}`} />
    </div>
  );
}
